import * as React from 'react';
import { SVGProps } from 'react';

const IconArrowPreviousSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.707 2.707 3.414 6l3.294 3.293L6 10 2 6l4-4 .707.707Zm3.293 0L6.707 6 10 9.293 9.293 10l-4-4 4-4 .707.707Z"
    />
  </svg>
);
export default IconArrowPreviousSizeXs;
